import { Users as UsersIcon } from "lucide-react";
import useUsers from "../../hooks/useUsers";
import GlassCard from "../ui/GlassCard";
import StatPill from "../ui/StatPill";
const Users = () => {
  const { users, loading } = useUsers("Monthly");
 

  return (
    
    <GlassCard accent="teal" className="text-white">
      <StatPill
      loading={loading}
        icon={<UsersIcon size={20} />}
        value={users}
        label="Total Users"
        accent="#45D9C0"
      />
    </GlassCard>
  );
};
var Users_default = Users;
export { Users_default as default };
